const parallaxImages = document.querySelectorAll('.block-bgImage--fixed');
parallaxImages.forEach((parallaxImage, index) => {
    window.addEventListener('scroll', function() {
        const parallaxContainer = parallaxImage.parentNode;
        const containerRect = parallaxContainer.getBoundingClientRect();
        const containerTop = containerRect.top;
        const windowHeight = window.innerHeight;
        const parallaxSpeed = 0.5;

        if (containerTop < windowHeight && containerTop > -containerRect.height) {
            const scrollPosition = window.pageYOffset - parallaxContainer.offsetTop;
            parallaxImage.style.transform = `translateY(${scrollPosition * parallaxSpeed}px)`;
        }
    });
});
